const prefix = 'fac';
const iconName = 'merge-clear';
const width = 515;
const height = 515;
const ligatures = [];
const unicode = null;
const svgPathData = 'M447 160C484.555 160 515 190.445 515 228V447C515 484.555 484.555 515 447 515H228C190.445 515 160 484.555 160 447V390H283C342.647 390 391 341.647 391 282V160H447Z M291 68C291 65.7909 289.209 64 287 64L266 64V1.73097e-05L287 1.91456e-05C324.262 2.34259e-05 354.524 29.9708 354.994 67.1211L355 68V89H291V68ZM138 6.11959e-06L218 1.31134e-05L218 64L138 64L138 6.11959e-06ZM1.91456e-05 68L0.0058786 67.1211C0.472756 30.2633 30.2633 0.47273 67.1211 0.0058593L68 0L90 1.9233e-06V64H68C65.7909 64 64 65.7909 64 68L64 89L1.73097e-05 89L1.91456e-05 68ZM291 137L355 137V217L291 217V137ZM1.31134e-05 137H64L64 217H6.11959e-06L1.31134e-05 137ZM266 291H287C289.209 291 291 289.209 291 287V265H355V287C355 324.555 324.555 355 287 355H266V291ZM67.1211 354.994C29.9708 354.524 -2.23465e-06 324.262 0 287L1.9233e-06 265H64V287C64 289.209 65.7909 291 68 291H90L90 355H68L67.1211 354.994ZM138 291H218V355H138V291Z';

export const definition = {
    prefix,
    iconName,
    icon: [
        width,
        height,
        ligatures,
        unicode,
        svgPathData,
    ],
};

export { definition as faMergeClear };
